import React from 'react';
import Modal from 'react-modal';

import { ReactComponent as Close } from '../../../icons/close.svg';

import './dialog.scss';

import { Button } from '../button/Button';

Modal.setAppElement('#root');

const Dialog = ({
  isOpen,
  icon: Icon,
  title,
  message,
  primaryText,
  secondaryText,
  onPrimaryClick,
  onSecondaryClick,
  onClose,
  loading
}) => {
  return (
    <Modal isOpen={isOpen} overlayClassName="dialog__overlay" className="dialog__content">
      <div className="dialog">
        <div>
          <Close width={24} height={24} onClick={onClose} />
        </div>
        {Icon && Icon}
        {title && <h1>{title}</h1>}
        {message && <span>{message}</span>}
        <div>
          {primaryText && (
            <Button onClick={onPrimaryClick} loading={loading}>
              {primaryText}
            </Button>
          )}
          {secondaryText && (
            <Button onClick={onSecondaryClick} outline>
              {secondaryText}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default Dialog;
